/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../../Components/GenericComponents/AddOrUpdateModel";
import { Tabs, Tab, Box, Divider } from "@mui/material";
import FgoGeneralForm from "./FgoGeneralForm";
import FgoClientForm from "./FgoClientForm";
import FgoContentForm from "./FgoContentForm";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";

export class FgoFormData {
  _id = null;
  Text = "";
  Explicatii = "";
  Valuta: string | null = null;
  TipFactura: string | null = null;
  DataEmitere: Date | null = null;
  DataScadenta: Date | null = null;
  Numar = "";
  Serie = "1";
  TvaLaIncasare: boolean | undefined;
  VerificareDuplicat: boolean | undefined;
  ValideazaCodUnicRo: boolean | undefined;
  IdExtern = "";
  Client = new FgoClient();
  Continut: Array<FgoItems> = [];
}

export class FgoClient {
  Denumire = "";
  CodUnic = "";
  NrRegCom = "";
  Email = "";
  Telefon = "";
  Tara: any;
  Judet: any;
  Localitate: any;
  Adresa = "";
  Tip: any;
  IdExtern = 0;
  ContBancar = "";
  PlatitorTVA: boolean | null = null;
}

export class FgoItems {
  Denumire = "";
  CodArticol = "";
  CodGestiune = "";
  Descriere = "";
  PretUnitar = 0;
  PretTotal = 0;
  UM = "";
  NrProduse = 0;
  CotaTVA = 0;
  CodCentruCost = 1;
}

type FgoMainPageProps = {
  open: boolean;
  onClose: () => void;
  editItem: FgoFormData | null;
  setShouldUpdate: React.Dispatch<boolean>;
};

export default function FgoMainPage(props: FgoMainPageProps) {
  const { open, onClose, editItem, setShouldUpdate } = props;
  const ref: any = useRef();
  const [tabIndex, setTabIndex] = useState(0);
  const [formData, setFormData] = useState<FgoFormData>(new FgoFormData());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  useEffect(() => {
    if (editItem) {
      setFormData(editItem);
    }
  }, []);

  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  const handleChange = (field: any, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleClientChange = (field: any, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      Client: {
        ...prev.Client,
        [field]: value,
      },
    }));
  };

  const handleContentChange = (index: any, field: any, value: any) => {
    const updatedContent = [...formData.Continut];
    updatedContent[index] = { ...updatedContent[index], [field]: value };
    setFormData((prev: any) => ({
      ...prev,
      Continut: updatedContent,
    }));
  };

  const removeContentItem = (index: number) => {
    setFormData((prev: FgoFormData) => ({
      ...prev,
      Continut: prev.Continut.filter((_, i) => i !== index),
    }));
  };

  const addContentItem = () => {
    setFormData((prev: any) => ({
      ...prev,
      Continut: [...prev.Continut, new FgoItems()],
    }));
  };

  return (
    <ValidatorForm
      ref={ref}
      onSubmit={async () => {
        await postData(urlEnum.fgo, formData);
        onClose();
      }}
    >
      <AddOrUpdateModel
        open={open}
        title="Add FGO"
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => {
          setShouldUpdate(true);
        }}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        {formData._id ? (
          <Box sx={{ padding: 2 }}>
            <p>
              <b>{Vocabulary.text}:</b> {formData.Text}
            </p>
            <p>
              <b>{Vocabulary.explication}:</b> {formData.Explicatii}
            </p>
            <p>
              <b>{Vocabulary.invoiceType}:</b> {formData.TipFactura}
            </p>
            <p>
              <b>{Vocabulary.currency}:</b> {formData.Valuta}
            </p>
            <p>
              <b>{Vocabulary.issueDate}:</b> {formData.DataEmitere?.toString()}
            </p>
            <p>
              <b>{Vocabulary.dueDate}:</b> {formData.DataScadenta?.toString()}
            </p>
            <p>
              <b>{Vocabulary.number}:</b> {formData.Numar}
            </p>
            <p>
              <b>{Vocabulary.serial}:</b> {formData.Serie}
            </p>
            <p>
              <b>{Vocabulary.externId}:</b> {formData.IdExtern}
            </p>
            <Divider />
            <p>
              <b>Denumire:</b> {formData.Client.Denumire}
            </p>
            <p>
              <b>CodUnic:</b> {formData.Client.CodUnic}
            </p>
            <p>
              <b>Email:</b> {formData.Client.Email}
            </p>
            <p>
              <b>Telefon:</b> {formData.Client.Telefon}
            </p>
            <p>
              <b>Adresa:</b> {formData.Client.Adresa}
            </p>
            <p>
              <b>Localitate:</b> {formData.Client.Localitate}
            </p>
            <p>
              <b>Judet:</b> {formData.Client.Judet}
            </p>
            <p>
              <b>Tara:</b> {formData.Client.Tara}
            </p>
            {formData.Continut.length > 0 ? (
              formData.Continut.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    mb: 2,
                    p: 1,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                  }}
                >
                  <p>
                    <b>Denumire:</b> {item.Denumire}
                  </p>
                  <p>
                    <b>PretUnitar:</b> {item.PretUnitar}
                  </p>
                  <p>
                    <b>NrProduse:</b> {item.NrProduse}
                  </p>
                  <p>
                    <b>PretTotal:</b> {item.PretTotal}
                  </p>
                  <p>
                    <b>CotaTVA:</b> {item.CotaTVA}
                  </p>
                </Box>
              ))
            ) : (
              <p>No content items</p>
            )}
          </Box>
        ) : (
          <>
            <Tabs
              value={tabIndex}
              onChange={(e, newValue) => setTabIndex(newValue)}
            >
              <Tab label={Vocabulary.general} />
              <Tab label={Vocabulary.client} />
              <Tab label={Vocabulary.content} />
            </Tabs>

            <Box sx={{ padding: 2 }}>
              {tabIndex === 0 && (
                <FgoGeneralForm
                  formData={formData}
                  handleChange={handleChange}
                />
              )}
              {tabIndex === 1 && (
                <FgoClientForm
                  clientData={formData.Client}
                  handleClientChange={handleClientChange}
                />
              )}
              {tabIndex === 2 && (
                <FgoContentForm
                  contentItems={formData.Continut}
                  handleContentChange={handleContentChange}
                  addContentItem={addContentItem}
                  removeContentItem={removeContentItem}
                />
              )}
            </Box>
          </>
        )}
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
